export default __webpack_public_path__ + "static/media/accept.0e04786e.svg";